<template>
  <div>
    <div
      v-if="isEnabledLpuClub"
      class="lpu-price-switcher"
      :class="{ 'lpu-price-switcher_sticky': isSticky }"
    >
      <div :class="{ 'w-100 px-6': isSticky }">
        <template
          v-if="userClubData.isInClub"
        >
          <ClubInfoBanner
            :show-info-icon="!infoBannerLink"
            title="Клубная цена"
            subtitle="На все услуги клиники"
            :fixed-bottom-value="switchFixedBottomValue"
            @club-info-banner:click="handleClubInfoBannerClick"
          />
        </template>
        <template
          v-else
        >
          <ClubDetailInfoBanner
            v-if="!hideDetailInfoBanner"
            :fixed-bottom-value="bannerFixedBottomValue"
            title="Цена только для пациентов в клубе"
            text-button="Продолжить"
            :subtitle="`-${discountOnServices}% на услуги в клиниках клуба и -30% на приёмы врачей.`"
            :hide="!isEnabled"
            class="mb-2"
          />
          <ClubDiscountSwitch
            use-global-dispatch
            title="Клубная цена"
            :fixed-bottom-value="switchFixedBottomValue"
            :discount="discountOnServices"
            :enabled="isEnabled"
            @club-discount-switch:click="handleClubDiscountSwitchClick"
          />
        </template>
      </div>
    </div>

    <ClubInfoModal
      v-if="isEnabledLpuClub && userClubData.isInClub"
      show-club-service-price-info
      :user-club-data="userClubData"
      :user-phone="userPhone"
    />
  </div>
</template>

<script>
import { dispatchCustomEventGlobally } from 'www/utils'
import BtnFixed from 'www/doctors.mobile.blocks/common/b-btn-fixed/b-btn-fixed'
import { eventsData } from 'www/vue_components/common/Club/components/core/ClubCardGetting/interfaces'

import ClubInfoBanner from 'www/vue_components/common/Club/components/core/ClubInfoBanner/ClubInfoBanner.vue'
import ClubDetailInfoBanner from 'www/vue_components/common/Club/components/core/ClubDetailInfoBanner/ClubDetailInfoBanner.vue'
import ClubInfoModal from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/components/common/ClubInfoModal.vue'
import ClubDiscountSwitch from 'www/vue_components/common/Club/components/core/ClubDiscount/components/common/ClubDiscountSwitch.vue'

import { CLUB_ATTRS } from 'www/vue_components/common/Club/components/dependencies/ClubLpuPriceSwitcher/constants'

export default {
  name: 'ClubLpuPriceSwitcher',
  components: {
    ClubInfoModal,
    ClubInfoBanner,
    ClubDiscountSwitch,
    ClubDetailInfoBanner,
  },
  props: {
    isEnabledSwitch: {
      type: Boolean,
      default: false,
    },
    isEnabledLpuClub: {
      type: Boolean,
      default: false,
    },
    switchFixedBottomValue: {
      type: String,
      default: '',
    },
    bannerFixedBottomValue: {
      type: String,
      default: '',
    },
    infoBannerLink: {
      type: String,
      default: '',
    },
    hideDetailInfoBanner: {
      type: Boolean,
      default: false,
    },
    isSticky: {
      type: Boolean,
      default: false,
    },
  },
  data: vm => ({
    events: eventsData,
    userClubData: window.USER.club,
    userPhone: window.USER.userPhone,
    discountOnServices: window.USER.club.discountOnServices,
    isEnabled: vm.isEnabledSwitch,
  }),
  created() {
    window.addEventListener('club-service-discount:updated-user-data', ({ detail }) => {
      this.userClubData = { ...this.userClubData, ...detail.userClubData }

      if (this.userClubData.isInClub) {
        this.handleClubDiscountSwitchClick(true)
      }
    })
    window.addEventListener(this.events.userAuth.confirmed, ({ detail }) => {
      this.userPhone = detail.userPhone
    })
  },
  mounted() {
    if (this.isSticky) {
      new BtnFixed({
        buttonSelector: '.lpu-price-switcher',
        activeClassName: 'lpu-price-switcher_sticky_active',
        sectionOffset: {
          top: 260,
          bottom: 130,
        },
        limitSelectors: {
          section: '.b-doctor-details__item',
        },
      })
    }
  },
  methods: {
    handleClubDiscountSwitchClick(isEnabled) {
      this.isEnabled = isEnabled;

      [...document.querySelectorAll(`[${CLUB_ATTRS.switcher}="true"]`)].forEach(node => { node.hidden = !isEnabled });
      [...document.querySelectorAll(`[${CLUB_ATTRS.switcher}="false"]`)].forEach(node => { node.hidden = isEnabled });

      [...document.querySelectorAll(`[${CLUB_ATTRS.priceLink}]`)].forEach(node => {
        const isPrg = node.classList.contains('b-prg')

        if (isPrg) {
          const prgInputUrl = node.querySelector('[name="url"]')
          const urlInstance = new URL(prgInputUrl.value, window.location.origin)

          this.toggleSwitchQueryParam(urlInstance)

          prgInputUrl.value = urlInstance.href

          return
        }

        const urlInstance = new URL(node.href, window.location.origin)

        this.toggleSwitchQueryParam(urlInstance)

        node.href = urlInstance.href
      })
    },
    toggleSwitchQueryParam(url) {
      if (this.isEnabled) {
        url.searchParams.set('club_switch_on', '')
      } else {
        url.searchParams.delete('club_switch_on')
      }
    },
    handleClubInfoBannerClick() {
      if (this.infoBannerLink) {
        window.location.assign(this.infoBannerLink)

        return
      }

      dispatchCustomEventGlobally('club-info-modal:open')
    },
  },
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/variables';
@import '~www/themes/doctors/common/mixins';

.lpu-price-switcher {
  &_sticky {
    width: 960px;
    margin: 0 auto;
    display: flex;
    z-index: 5;
    position: fixed;
    bottom: 16px;
    left: 8px;
    right: 8px;
    transform: translateY(150px);
    transition: transform 0.2s ease-in-out;

    &_active {
      transform: translateY(0);
    }

    @include media-breakpoint-up(lg) {
      width: 1120px;
    }

    &::before {
      content: '';
      display: block;
      width: calc(24% + 4px);
      flex-shrink: 0;
    }
  }
}
</style>
